export default __webpack_public_path__ + "static/media/correspondent16.a3873eeb.png";